<template>
  <div>
    <div v-if="path == '/clientes/finish' || path == '/colaborador/finish'" :class="banner">
      <br>

    </div>

    <div class=" text-center footer">
      <br>

      <div class="text-center image">

        <!-- <v-img contain max-height="160px" :src="LogoFairfax" max-width="245" style=" margin: auto; " /> -->

      </div>

      <div :class="copyrightBox" class="text-center">

        <label :class="labelText">
          Hites S.A. ha gestionado a favor del funcionario Hites un valor especial para la prima SOAP auto, jeep y station wagon . 
          Valor prima $4.850. La póliza SOAP será emitida por Southbridge Compañía de Seguros Generales S.A. una vez procesado el 
          pago por parte del funcionario.
        </label>

        <br>

        <label :class="labelSubText">
          Copyright© 2025 Southbridge Compañía de Seguros Generales S.A. Todos los Derechos Reservados.
        </label>
      </div>


    </div>

  </div>
</template>

<script>
import LogoFairfax from "@/assets/images/FairfaxLogo.svg";

export default {
  name: "Footer",
  mounted() {
  },
  data: () => ({
    LogoFairfax,
    copyrightBox: null,
    path: null,
    puntos: null,
    screen: null,
    banner: null,
    texto: null,
    labelText: null,
    labelSubText: null,
  }),
  mounted() {
    this.path = window.location.pathname;
    if (this.path == '/clientes/finish') {
      this.puntos = '7.000'
    } else if (this.path == '/colaborador/finish') {
      this.puntos = '10.000'
    }
    this.screen = window.screen.width
    if (this.screen > 767) {
      this.banner = 'text-center banner'
      this.texto = 'texto'
      this.copyrightBox = 'copyrightBox'
      this.labelText = 'labelText'
      this.labelSubText = 'labelSubText'
    } else {
      this.banner = 'text-center banner2'
      this.texto = 'texto2'
      this.copyrightBox = 'copyrightBox2'
      this.labelText = 'labelText2'
      this.labelSubText = 'labelSubText2'
    }
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
@import url("../styles/main.scss");

.copyrightBox {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Arial', sans-serif;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}

.labelText {
  background-color: #2D387C;
  min-height: 100px;
  text-align: center;
  margin: 0;
  padding: 10px;
  display: block;
  width: 100%;
  text-align: justify;
}

.labelText2 {
  background-color: #2D387C;
  min-height: 100px;
  text-align: center;
  margin: 0;
  padding: 10px;
  display: block;
  width: 100%;
  text-align: justify;
}

.labelSubText {
  background-color: rgba(0, 7, 47, 1);
  min-height: 50px;
  min-width: 100%;
  margin: 0;
  padding: 10px;
  display: block;
  width: 100%;
  margin-top: -2%;
}

.labelSubText2 {
  background-color: rgba(0, 7, 47, 1);
  min-height: 50px;
  min-width: 100%;
  margin: 0;
  padding: 10px;
  display: block;
  width: 100%;
  margin-top: -7%;
}

.copyrightBox2 {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Arial', sans-serif;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
}

.cobertura {
  text-align: center;

  letter-spacing: 0.3px;
  color: #FFFFFF;
  text-transform: uppercase;
  opacity: 1;
  font-family: 'Arial', sans-serif;
  font-weight: bold;
}

.detalle {
  text-align: center;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #FFFFFF;
  opacity: 1;
  font-family: 'Arial', sans-serif;

}

// .footer {
//    height: 130px;
//    background: #2D387C 0% 0% no-repeat padding-box;
// }

// .banner {
//height: 105%; 
// background: #FFF;
// }

.banner2 {
  height: 50%;
  // background: #0069B6;
}

.texto {
  width: 750px;
  height: 29px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  font-size: 40px;
  letter-spacing: 0px;
  color: white;
  opacity: 1;
  text-transform: initial;
}

.texto2 {
  width: 750px;
  height: 29px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  font-size: 20px;
  letter-spacing: 0px;
  color: white;
  opacity: 1;
  text-transform: initial;
}

.butoon {
  width: 310px;
  height: 64px;
  background: #EF7C00 0% 0% no-repeat padding-box;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  font: normal normal normal 30px Helvetica Neue;
  text-transform: initial;
  letter-spacing: 0.66px;
  color: white;
  opacity: 1;
}

.butoon2 {
  background: #EF7C00 0% 0% no-repeat padding-box;
  border-radius: 10px;
  opacity: 1;
  text-align: center;
  font: normal normal normal 30px Helvetica Neue;
  text-transform: initial;
  letter-spacing: 0.66px;
  color: white;
  opacity: 1;
}

.form-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.theme--light.v-btn.v-btn--has-bg {
  background: #EF7C00 0% 0% no-repeat padding-box;
}

.image {
  margin-top: 0%;
  margin-bottom: 1.5%;
}
</style>
